
import Modal from "react-bootstrap/Modal";
import deafultuserImg from "../../../assets/images/avatar.svg";
import { emergencyService } from "services/emergency.service";
import { useEffect, useState } from "react";

import { useFormik } from "formik";
import * as Yup from 'yup';
import { toast } from "react-toastify";
import { utilService } from "services";
import useCurrentUser from "hooks/useCurrentUser";
import { geocodeByLatLng } from "react-google-places-autocomplete";
import addressicon from "../../../assets/images/address.svg";
import GoogleMapModal from "../GoogleMapModal";
import useCountries from "hooks/useCountries";

function MissingForm(props) {
  const [showModal, setShowModal] = useState(false);

  const { show, handleClose } = props;
  const { user } = useCurrentUser();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userAddress, setUserAddress] = useState(null);
  const [location, setLocation] = useState({
    lat: 0,
    lng: 0,
  });
  const [readOnlyData, setReadOnlyData] = useState([])

  const { countries } = useCountries();

  const genderList = [
    {
      id: 1,
      title: "Male",
    },
    {
      id: 2,
      title: "Female",
    },
    {
      id: 3,
      title: "Others",
    },
  ]
  const formik = useFormik({
    initialValues: {
      requesterName: "",
      requesterEmail: "",
      description: "",
      type: "Missing",
      address: '',
      latitude: "",
      longitude: "",
      avatar: "",
      fullName: "",
      age: "",
      gender: "Male"
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      avatar: Yup.string().required("Please upload Avatar"),
      requesterName: Yup.string().required("Please enter Requster Name"),
      requesterEmail: Yup.string().required("Please enter Requster Email"),
      description: Yup.string().required("Please enter Description"),
      fullName: Yup.string().required("Please enter Full Name"),
      age: Yup.string().required("Please enter Age"),
      gender: Yup.string().required("Please enter Gender"),
      address: Yup.string().required("Please enter address"),
      latitude: Yup.string().required("Please enter Latitude"),
      longitude: Yup.string().optional(),
    }),
    onSubmit: async (values) => {
      if (!values?.address || !values?.latitude || !values?.longitude) {
        setError('Please Enable Location!')
        return;
      }
      values.missingPerson = {
        avatar: values.avatar,
        fullName: values.fullName,
        age: values.age,
        gender: values.gender
      }
      values.latitude = location.lat;
      values.longitude = location.lng;

      const keys = ['avatar', 'age', 'fullName', 'gender'];
      keys.forEach(item => delete values[item])
      setIsLoading(true);
      try {
        const response = await emergencyService.addMissingPerson(values)
        setTimeout(() => {
          setIsLoading(false);
          toast.success(response?.data?.message)
          handleClose();
          formik.resetForm()


        }, 2000);
      } catch (err) {
        console.error(err?.response?.data?.message);
        setError(err?.response?.data?.message);
      }
    },
  });

  const handleFileUpload = async (e) => {
    setError(null);

    const file = e.target.files[0];
    const extension = file.name.split('.').pop();


    try {
      setIsLoading(true);
      const response = await utilService.getBucketUrl({
        location: 'users/',
        extension
      })
      const webUrlData = response.data.data[0];
      const { filename, url } = webUrlData || {};

      const requestOptions = {
        method: 'PUT',
        headers: {
          "Content-Type": file.type
        },
        body: file,
        redirect: 'follow'
      };

      await utilService.uploadFile({
        url,
        requestOptions
      })
      formik?.setFieldValue("avatar", filename)
    }
    catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (show) {
      navigator.geolocation.getCurrentPosition(position => {
        const { latitude, longitude } = position.coords;
        const pos = {
          lat: latitude,
          lng: longitude
        }
        if (pos?.lat && pos?.lng) {
          geocodeByLatLng(pos)
            .then(res => {
              formik.setFieldValue('address', res[0].formatted_address);
              formik.setFieldValue("latitude", pos.lat || "");
              formik.setFieldValue("longitude", pos.lng || "");
            })
            .catch(err => console.log(err))
        }
      }, (err) => {
        console.log('enable location')
      });
    }
  }, [navigator.geolocation, show]);

  const modalCloseHandler = () => {
    setShowModal(false);
  };

  return (
    <>
      <Modal
        show={show}
        className="modal-common alert-red-form"
        onHide={handleClose}
      >
        <Modal.Header className="text-center" closeButton>
          <p className="text-center mb-0">Missing Person</p>
        </Modal.Header>
        <Modal.Body>
          <form className="missing-form" onSubmit={formik.handleSubmit} id="missingForm">
            <div className="avatar-upload">
              <div className="avatar-edit">
                <input
                  type="file"
                  id="imageUpload"
                  accept=".png, .jpg, .jpeg"
                  onChange={handleFileUpload}
                />
                <label htmlFor="imageUpload" />
              </div>
              <div className="avatar-preview">
                <div id="imagePreview">
                  <img alt="" className="rounded-circle border border-dark"
                    style={!formik?.values?.avatar ? { filter: 'invert(1)' } : {}}
                    src={formik?.values?.avatar ? `${user?.baseS3Url}${formik?.values?.avatar}` : deafultuserImg}
                  />
                </div>
              </div>
              {formik.touched.avatar && formik.errors.avatar ? (
                <span className="text-danger mb-3">{formik.errors.avatar}</span>
              ) : null}
            </div>
            <div className="mb-30">
              <label className="py-2">Requester Name</label>
              <br />
              <div className="form-control-bg">
                <input
                  type="text"
                  name="requesterName"
                  id="requesterName"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik?.values?.requesterName}
                  className="form-control rounded-3  w-100"
                  required
                />
              </div>
              {formik.touched.requesterName && formik.errors.requesterName ? (
                <span className="text-danger">{formik.errors.requesterName}</span>
              ) : null}
            </div> <div className="mb-30">
              <label className="py-2">Requester Email</label>
              <br />
              <div className="form-control-bg">
                <input
                  type="text"
                  name="requesterEmail"
                  id="requesterEmail"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik?.values?.requesterEmail}
                  className="form-control rounded-3  w-100"
                  required
                />
              </div>
              {formik.touched.requesterEmail && formik.errors.requesterEmail ? (
                <span className="text-danger">{formik?.errors?.requesterEmail}</span>
              ) : null}
            </div>
            <div className="mb-30">
              <label className="py-2">Full Name</label>
              <br />
              <div className="form-control-bg">
                <input
                  type="text"
                  name="fullName"
                  id="fullName"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik?.values?.fullName}
                  className="form-control rounded-3  w-100"
                  required
                />
              </div>
              {formik.touched.fullName && formik.errors.fullName ? (
                <span className="text-danger">{formik?.errors?.fullName}</span>
              ) : null}
            </div>
            <div className="mb-30">
              <label className="py-2">Gender</label>
              <br />
              <div className="form-control-bg">
                <select className="w-100 rounded-3 select-dropdown area-arrow" name="gender"
                  id="gender"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik?.values?.gender}
                >
                  {genderList?.map((item, i) => {
                    return (<option key={item?.title}>{item?.title} </option>)
                  })}
                </select>
              </div>
              {formik.touched.gender && formik.errors.gender ? (
                <span className="text-danger">{formik?.errors?.gender}</span>
              ) : null}
            </div>
            <div className="mb-30">
              <label className="py-2 ">Age</label>
              <br />
              <div className="form-control-bg">
                <input
                  type="text"
                  name="age"
                  id="age"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik?.values?.age}
                  className="form-control rounded-3  w-100"
                  required
                />
              </div>
              {formik.touched.age && formik.errors.age ? (
                <span className="text-danger">{formik?.errors?.age}</span>
              ) : null}
            </div>
            <div className="mb-10">
              <label className=" ">Description</label>
              <br />
              <div className="form-control-bg">
                <div className="textrea-overlay w-100">
                  <textarea
                    className="form-control"
                    name="description"
                    id="description"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}

                    value={formik?.values?.description}
                    rows="6"
                    maxLength={1000}
                  ></textarea>
                </div>
              </div>
              <label className="d-block text-end pt-1 pe-1">{formik.values.description.length}/1000</label>
              {formik.touched.description && formik.errors.description ? (
                <span className="text-danger">{formik?.errors?.description}</span>
              ) : null}
            </div>
            {error && <div className="text-danger">{error}</div>}

            <div className="mb-10">
              <label className="py-2">Address</label>
              <br />

              <div className="addres-icon rounded-3 bg-cyan w-100 px-3 py-3">
                <input
                  type="text"
                  placeholder="Enter Address"
                  className="w-100 bg-transparent border-0"
                  name="address"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.address}
                  readOnly
                />

                <img
                  onClick={() => setShowModal(true)}
                  alt='' src={addressicon}
                  className="cursor-pointer"
                />
              </div>
              {formik.touched.address && formik.errors.address ? (
                <span className="text-danger">{formik.errors.address}</span>
              ) : null}
            </div>

          </form>


        </Modal.Body>
        <Modal.Footer>
          <button
            type="submit"
            form="missingForm"
            className="btn btn-primary modal-red-btn text-capitalize w-100 text-white"
          >
            {isLoading ? "Loading..." : "Submit"}
          </button>
        </Modal.Footer>
      </Modal>
      <GoogleMapModal
        show={showModal}
        closeHandler={modalCloseHandler}
        setUserAddress={(address) => {
          setUserAddress(address)
          formik.setFieldValue('address', address)
        }}
        location={location}
        setLocation={setLocation}
        setReadOnlyData={setReadOnlyData}
        countries={countries}
        userAddress={userAddress}
      />
    </>
  );
}

export default MissingForm;
